class ScheduledContent {
  constructor() {
    this.observer = null;
    this.onDomReady = this.onDomReady.bind(this);
  }

  parseInteger(value) {
    const parsed = parseInt(value, 10);
    return Number.isNaN(parsed) ? null : parsed;
  }

  getDateFromAttributes(el, prefix) {
    const month = this.parseInteger(el.getAttribute('data-' + prefix + '-month'));
    const day = this.parseInteger(el.getAttribute('data-' + prefix + '-day'));
    const year = this.parseInteger(el.getAttribute('data-' + prefix + '-year'));

    if (month == null || day == null || year == null) return null;

    // Month in HTML is likely 1-12; JS Date expects 0-11
    if (prefix === 'start') {
      return new Date(year, month - 1, day, 0, 0, 0, 0);
    }
    return new Date(year, month - 1, day, 23, 59, 59, 999);
  }

  shouldShow(el, now) {
    // If explicitly set to always show, respect it
    const showAlwaysAttr = el.getAttribute('data-show-always');
    if (showAlwaysAttr && showAlwaysAttr.toString().toLowerCase() === 'true') return true;

    const scheduleType = (el.getAttribute('data-schedule-type') || 'show').toLowerCase();
    const startDate = this.getDateFromAttributes(el, 'start');
    const endDate = this.getDateFromAttributes(el, 'end');

    // If no dates configured, default to show
    if (!startDate && !endDate) return true;

    let inRange = false;
    if (startDate && endDate) {
      inRange = now >= startDate && now <= endDate;
    } else if (startDate && !endDate) {
      inRange = now >= startDate;
    } else if (!startDate && endDate) {
      inRange = now <= endDate;
    }

    if (scheduleType === 'hide') {
      return !inRange;
    }
    // Default behavior: show during the scheduled range
    return inRange;
  }

  setVisibility(el, visible) {
    if (visible) {
      el.style.removeProperty('display');
      el.hidden = false;
      el.setAttribute('aria-hidden', 'false');
    } else {
      el.style.display = 'none';
      el.hidden = true;
      el.setAttribute('aria-hidden', 'true');
    }
  }

  process(root) {
    const now = new Date();
    const selector = '[data-schedule-type]';
    const elements = (root || document).querySelectorAll(selector);

    elements.forEach ? elements.forEach((el) => {
      const visible = this.shouldShow(el, now);
      this.setVisibility(el, visible);
    }) : Array.prototype.forEach.call(elements, (el) => {
      const visible = this.shouldShow(el, now);
      this.setVisibility(el, visible);
    });
  }

  observe() {
    if (!window.MutationObserver) return;

    this.observer = new MutationObserver((mutations) => {
      let needsScan = false;
      for (let i = 0; i < mutations.length; i++) {
        const m = mutations[i];
        if ((m.addedNodes && m.addedNodes.length) || m.type === 'childList' || m.type === 'attributes') {
          needsScan = true;
          break;
        }
      }
      if (needsScan) this.process(document);
    });

    this.observer.observe(document.documentElement || document.body, {
      childList: true,
      subtree: true,
      attributes: false
    });
  }

  refresh(root) {
    this.process(root || document);
  }

  onDomReady() {
    this.process(document);
    this.observe();
  }
}

const scheduledContent = new ScheduledContent();
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', scheduledContent.onDomReady);
} else {
  scheduledContent.onDomReady();
}
window.ScheduledContent = scheduledContent;
